import axios from "axios";
import { Message } from "element-ui";
import router from "../router/index";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

const baseApi = process.env.VUE_APP_BASE_API?.trim() || `${window.location.origin}/api`;
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseApi,
  // 超时
  timeout: 50000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["Auth-Token"] = localStorage.getItem("TOKEN") || "";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    const code = res.data.code || 200;
    // 200004 未上传过作品
    // 200003 已上传作品
    // 500013 用户信息补全
    if (
      code == 200 ||
      code == 200001 ||
      code == 200002 ||
      code === 200004 ||
      code === 200003 ||
      code === 500013 || // 用户信息缺失，补全信息
      code === 500014 // 证书不存在
    ) {
      return res.data;
    } else if (code == 120) {
      // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
      //   location.href = '/login';
      //   localStorage.removeItem('TOKEN');
      //   localStorage.removeItem('USERINFO');
      // })
      // location.href = '/login';
      router.push("/login");
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("USERINFO");
    } else {
      Message({ message: res.data.msg, type: "error" });
      return Promise.reject(res);
    }
  },
  (error) => {
    console.log(error, "90909009909");
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: "error" });
    return Promise.reject(error);
  }
);

export default service;
